import script from "./QHeaderSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./QHeaderSupport.vue?vue&type=script&setup=true&lang=js"

import "./QHeaderSupport.vue?vue&type=style&index=0&id=2e55e77b&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e55e77b"]])

export default __exports__